import iconBtc from 'assets/images/Chains/btc.svg';
// import iconEth from 'assets/images/Chains/eth.svg';
// import iconBob from 'assets/images/Chains/bob.svg';
import iconMerlin from 'assets/images/Chains/merlin.svg';
// import iconBaseSepolia from 'assets/images/Chains/base.svg';
// import iconModeSepolia from 'assets/images/Chains/mode.svg';
//import iconArbitrum from 'assets/images/Chains/arbitrum.svg';
import iconCore from 'assets/images/Chains/core.svg';
import { ChainId } from 'types/chains';
export const MIN_BTC_AMOUNT = 0.00002;
export const MAX_BTC_AMOUNT = 1;
export const SOURCE_CHAINS = [
    {
        id: 4,
        label: 'Bitcoin Testnet',
        icon: iconBtc,
    },
];
export const DESTINATION_CHAINS = [
    // {
    //   id: ChainId.Sepolia,
    //   label: 'Ethereum Sepolia',
    //   icon: iconEth,
    // },
    {
        id: ChainId.MerlinTestnet,
        label: 'Merlin Testnet',
        icon: iconMerlin,
    },
    // {
    //   id: ChainId.EthereumHolesky,
    //   label: 'Ethereum Holesky',
    //   icon: iconEth,
    // },
    // {
    //   id: ChainId.BobSepolia,
    //   label: 'Bob Sepolia',
    //   icon: iconBob,
    // },
    // {
    //   id: ChainId.BaseSepolia,
    //   label: 'Base Sepolia',
    //   icon: iconBaseSepolia,
    // },
    // {
    //   id: ChainId.ModeSepolia,
    //   label: 'Mode Sepolia',
    //   icon: iconModeSepolia,
    // },
    // {
    //   id: ChainId.ArbitrumSepolia,
    //   label: 'Arbitrum Sepolia',
    //   icon: iconArbitrum,
    // },
    { id: ChainId.CoreTestnet2, label: 'Core Testnet 2', icon: iconCore },
];
export const MERLIN_FAUCET_API = 'https://patagonia-airdroper-merlin.bitcoinos.build/fundAddress';
export const LOG_PEGIN_REQUESTS_API = 'https://patagonia-airdroper-merlin.bitcoinos.build/logPeginRequest';
export const GET_PEGIN_LOGS_API = 'https://patagonia-airdroper-merlin.bitcoinos.build/getHistory';
export const GAS_COST_MAP = {
    [ChainId.MerlinTestnet]: 0.0004,
    [ChainId.ModeSepolia]: 0.0004,
    [ChainId.Sepolia]: 0.0004,
    [ChainId.EthereumHolesky]: 0.0004,
    [ChainId.BaseSepolia]: 0.0004,
    [ChainId.ArbitrumSepolia]: 0.0004,
    [ChainId.CoreTestnet2]: 0.01,
};
